import { BrandLogo, Spinner } from '@elva/ui';
import { getAppConfig } from '../../config/appConfigRef';

export interface AuthLoadingScreenProps {
  logoSrc?: string;
  message?: string;
}

export function AuthLoadingScreen({
  logoSrc,
  message = 'Initializing...',
}: AuthLoadingScreenProps) {
  const appName = getAppConfig().appName;

  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--cream-0)]">
      <div className="flex flex-col items-center gap-4">
        <div className="flex items-center gap-2">
          {logoSrc ? <BrandLogo src={logoSrc} alt={appName} className="h-8 w-8" /> : null}
          <span className="font-[var(--font-display)] text-lg font-semibold text-[var(--ink-0)]">
            {appName}
          </span>
        </div>
        <div className="flex items-center gap-2 text-sm text-[var(--ink-2)]">
          <Spinner size={20} />
          <span>{message}</span>
        </div>
      </div>
    </div>
  );
}
